import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class ProductCategoryForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'udgivelse-varegrupper', dataApiName: 'ProductCategory', text: 'Kategorier, udgivelser', textSingular: "Varegrupper (boghandler)",
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history']
      }
    });
  }
}
